import React from 'react';
import SkuStore from '@/stores/sku';
import ExpressStore from '@/stores/express';
import RoundNumber from '@/common/round-number';
import localFormat from '@/common/local-format';

interface PropType {
  type: SkuTypes.TypeInfo;
  price: PriceTypes.Root;
  i18n: DetailTypes.i18n;
}

export default function Total(props: PropType) {
  const { type = 'product', price, i18n } = props;
  const skuInfo = SkuStore((state) => state[type]);
  const expressInfo = ExpressStore((state) => state[type]);
  const { logisticPrice } = expressInfo;
  const { quantity } = skuInfo;

  const {
    unit,
    currencyRule: { rate, maximumFractionDigits },
  } = price;

  // 价格需要向上取整后统计

  const renderPrice = (onlyTotal = false) => {
    const totalPrice = RoundNumber(
      type === 'sample' ? skuInfo.totalPrice : skuInfo.totalPrice * rate,
      maximumFractionDigits,
    );
    const totalExpress = logisticPrice
      ? RoundNumber(logisticPrice * rate, maximumFractionDigits)
      : 0;

    const subTotal = totalPrice + totalExpress;
    if (onlyTotal) return localFormat(subTotal);
    if (quantity > 1)
      return `${localFormat(subTotal)} (${localFormat(
        (subTotal / quantity).toFixed(maximumFractionDigits),
      )}/${unit})`;
    if (quantity === 0) return localFormat(0);
    return localFormat(subTotal);
  };

  return (
    <div className="bottom-item total">
      <div className="item-left">{i18n['pc_detail_sku_panel_subtotal']}</div>
      <div className="item-right" data-price-total={renderPrice(true)}>
        {renderPrice()}
      </div>
    </div>
  );
}
